// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"function-curve"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 16H21M7 21L7 3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M4 5C4.26667 9.84051 6.24 19.6152 12 19.99C17.76 20.3647 19.7333 10.1528 20 5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FunctionCurveIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'function-curve',
    ref,
    icon: element,
  },
));

FunctionCurveIcon.displayName = 'FunctionCurveIcon';

export default FunctionCurveIcon;
